<template>
    <div>
        <h2>{{$t('intern_objekte_list.kunden_login')}}</h2>
        <div class="row mb-3" v-if="active_packets && count_status && user">
            <div class="col-12 col-md-6">
                <h4 class="mm-color">{{$t('intern_objekte_list.meine_artikel')}}</h4>
                <div class="row">
                    <div class="col-9 col-md-9">{{$t('intern_objekte_list.gebuchte_artikel')}}</div>
                    <div class="col-3 col-md-3">{{getPacketValue('quota')}}</div>
                </div>
                <div class="row">
                    <div class="col-9 col-md-9">{{$t('intern_objekte_list.hochgeladene_artikel')}}</div>
                    <div class="col-3 col-md-3">{{count}}</div>
                </div>
                <div class="row">
                    <div class="col-9 col-md-9">{{$t('intern_objekte_list.online_artikel')}}</div>
                    <div class="col-3 col-md-3">{{count_status.ok}}</div>
                </div>
                <div class="row">
                    <div class="col-9 col-md-9">{{$t('intern_objekte_list.offline_artikel')}}</div>
                    <div class="col-3 col-md-3">{{(count_status.new * 1) +(count_status.locked * 1)}}</div>
                </div>
                <div class="row">
                    <div class="col-9 col-md-9">{{$t('intern_objekte_list.rest_artikel')}}</div>

                    <div class="col-3 col-md-3" v-if="getPacketValue('quota') > 0">{{(getPacketValue('quota') * 1) - (count_status.ok * 1)}}</div>
                    <div class="col-3 col-md-3" v-else>{{(getPacketValue('quota') * 1)}}</div>
                </div>
                <div class="row" v-if="count_free > 0">
                  <div class="col-9 col-md-9">{{$t('intern_objekte_list.kostenlose_artikel')}}</div>
                  <div class="col-3 col-md-3">{{count_free}}</div>
                </div>
            </div>
            <div class="col-12 col-md-6">
                <h4 class="mm-color">{{$t('intern_objekte_list.meine_zusatzleistungen')}}</h4>
                <div class="row">
                    <div class="col-8 col-md-8">{{$t('intern_objekte_list.fotolinks')}}</div>
                    <div class="col-4 col-md-4">
                        {{active_packets.filter(item => item.packet_key == 'fotolink' && item.object_id != 0).length}}
                        von
                        {{getPacketValue('fotolink')}}
                    </div>
                </div>
                <div class="row">
                    <div class="col-8 col-md-8">{{$t('intern_objekte_list.fotokategorien')}}</div>
                    <div class="col-4 col-md-4">
                        {{active_packets.filter(item => item.packet_key == 'fotokategorie' && item.object_id != 0).length}}
                        von
                        {{getPacketValue('fotokategorie')}}
                    </div>
                </div>
                <div class="row">
                    <div class="col-8 col-md-8">{{$t('intern_objekte_list.topinserate')}}</div>
                    <div class="col-4 col-md-4">
                        {{active_packets.filter(item => item.packet_key == 'topinserat' && item.object_id != 0).length}}
                        von
                        {{getPacketValue('topinserat')}}
                    </div>
                </div>
                <div class="row">
                    <div class="col-8 col-md-8">{{$t('intern_objekte_list.dailypushups')}}</div>
                    <div class="col-4 col-md-4">
                        {{active_packets.filter(item => item.packet_key == 'dailypushup' && item.object_id != 0).length}}
                        von
                        {{getPacketValue('dailypushup')}}
                    </div>
                </div>
                <div class="row">
                    <div class="col-8 col-md-8">{{$t('intern_objekte_list.weeklypushups')}}</div>
                    <div class="col-4 col-md-4">
                        {{active_packets.filter(item => item.packet_key == 'weeklypushup' && item.object_id != 0).length}}
                        von
                        {{getPacketValue('weeklypushup')}}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                user: this.$store.state.user,
                overview: null,
                active_packets: null,
                count: 0,
                count_free: 0,
                count_paid: 0,
                count_status: null,
            }
        },
        watch: {
            overview(val) {
                if(val){
                    this.active_packets = val.active_packets;
                    this.count          = val.count;
                    this.count_free     = val.count_free;
                    this.count_paid     = val.count_paid;
                    this.count_status   = val.count_status;
                }
            }
        },
        methods: {
            getPacketValue(key) {
                if(this.user.user_type == 'gewerblich' || key == 'quota'){
                    if(!this.user.packet){
                        return 0;
                    }else{
                        return this.user.packet[key];
                    }
                }else if(this.user.user_type == 'alter_kunde'){
                    let num_of_active_improvements = Number(this.active_packets.filter(item => item.packet_key == key).length);

                    if(!this.user.packet){
                        return num_of_active_improvements;
                    }else if(Number(this.user.packet[key]) >= num_of_active_improvements){
                        return Number(this.user.packet[key]);
                    }else {
                        return Number(this.user.packet[key]) + (num_of_active_improvements - Number(this.user.packet[key]));
                    }
                }else{
                    return this.active_packets.filter(item => item.packet_key == key).length;
                }
            }
        },
        created() {
            this.overview = this.$store.state.overview;

            if(!this.overview){
                this.$store.dispatch('OVERVIEW');
            }
            this.$store.watch( () => {
                return this.$store.getters.user;
            }, user => {
                this.user = user;
            });

            this.$store.watch( () => {
                return this.$store.getters.overview;
            }, overview => {
                this.overview = overview;
            });
        }
    }
</script>

<style lang="scss" scoped>

</style>
